import React, { useState, useEffect, useRef } from "react";
// import "./Assessts/Styles/PrincipleDashboard.scss";
import { Row, Col } from "react-bootstrap";
import axios from "axios";
import GroupedStackedBarchart from "./GroupedStackedbar";
import Loading from "../../../Student/Reusablecomponents/Loading";
import {
  NumberToRoman,
  AssessmentName,
} from "../../../Student/Reusablecomponents/RegularFunctions";
import { useSelector, useDispatch } from "react-redux";
import { PrincipalTeacherDashboarData } from "../../../Redux/Reducers/Principle/PPerformanceT";
import { useNavigate } from "react-router-dom";
import { DownloadGraphButton, ExportXlButton } from "../../../ReusableComponents/CommonComponents";
import { DownloadGraphImage } from "../../../ReusableComponents/CommonFunctions";
import { saveAs } from "file-saver";
import ExcelJS from "exceljs";
import DropdownValues from "../../../Student/Reusablecomponents/DropDownValues";
import { InstituteGrades } from "../../../ReusableComponents/CommonApis";
const HQAPP = (props) => {
  const Grade610Ref = useRef(null);
  const Grade112Ref = useRef(null);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const items = useSelector((state) => state.userDetailsData.LoginDetails);
  const SelectDate = useSelector((state) => state.DateDetailsData.DateDetails);
  const USYear = useSelector((state) => state.SelecYearData.SYear);

  const [GraphData, SetGraphData] = useState({ Graph610: [], Graph112: [] });
  const [SelectGrade, SetSelectGrade] = useState({
    Grade610: [],
    Grade112: [],
  });

  const [PerformanceOne, SetPerformanceOne] = useState();
  const [Subjects, SetSubjects] = useState();
  const [Sections, SetSections] = useState();
  const [GetGrades, SetGetGrades] = useState();

  const [Performace112, SetPerformace112] = useState();
  const [Subjects112, SetSubjects112] = useState();
  const [Sections112, SetSections112] = useState();
  const [GetGrades112, SetGetGrades112] = useState();
  const [Load, SetLoad] = useState(false);
  const processData = (data) => {
    const groupedData = {};
    data.forEach((item) => {
      if (!groupedData[item.grade]) {
        groupedData[item.grade] = { grade: item.grade, subjects: {} };
      }
      groupedData[item.grade].subjects[item.subject] = item;
    });
    return groupedData;
  };

  const SubjectGradeWisePerformanceReport = async () => {
    SetLoad((prev) => !prev);
    await axios
      .get(
        process.env.REACT_APP_API_BASE_URL +
        `/Principal/GetSubjectGradeWisePerformanceReport?SchoolId=${props.SSchoolId}&ContestCreationId=${SelectDate?.value}&AssessmentType=${SelectDate?.assessmentType}`,
        { headers: { XApiKey: process.env.REACT_APP_XApiKey } }
      )
      .then((res) => {
        SetLoad((prev) => !prev);
        if (res.data?.[0].grade) {
          SetGraphData((prevState) => ({ ...prevState, Graph610: res.data }));
          SetPerformanceOne(processData(res.data));
          const Grades = [...new Set(res.data.map((Class) => Class.grade))];
          SetGetGrades(Grades);
          SetSelectGrade((prevState) => ({
            ...prevState,
            Grade610: Grades[0],
          }));
          SetSubjects([...new Set(res.data.map((item) => item.subject))]);
          SetSections([
            ...new Set(
              res.data.flatMap((item) =>
                Object.keys(item).filter(
                  (key) => key !== "subject" && key !== "grade"
                )
              )
            ),
          ]);
        } else {
          SetGraphData((prevState) => ({ ...prevState, Graph610: "" }));
          SetPerformanceOne(process.env.REACT_APP_NODATAFOUND_Participated);
        }
      })
      .catch((err) => console.log(err));
  };

  const PerformanceReportForGrade11And12 = async () => {
    await axios
      .get(
        process.env.REACT_APP_API_BASE_URL +
        `/Principal/GetPerformanceReportForGrade11And12?SchoolId=${props.SSchoolId}&ContestCreationId=${SelectDate?.value}&AssessmentType=${SelectDate?.assessmentType}`,
        { headers: { XApiKey: process.env.REACT_APP_XApiKey } }
      )
      .then((res) => {
        if (res.data?.[0].grade) {
          SetGraphData((prevState) => ({ ...prevState, Graph112: res.data }));
          SetPerformace112(processData(res.data));
          const Grades = [...new Set(res.data.map((Class) => Class.grade))];
          SetGetGrades112(Grades);
          SetSelectGrade((prevState) => ({
            ...prevState,
            Grade112: Grades[0],
          }));
          SetSubjects112([...new Set(res.data.map((item) => item.subject))]);
          SetSections112([
            ...new Set(
              res.data.flatMap((item) =>
                Object.keys(item).filter(
                  (key) => key !== "subject" && key !== "grade"
                )
              )
            ),
          ]);
        } else {
          SetGraphData((prevState) => ({ ...prevState, Graph112: "" }));
          SetPerformace112(process.env.REACT_APP_NODATAFOUND_Participated);
        }
      })
      .catch((err) => console.log(err));
  };

  useEffect(() => {
    if (SelectDate?.value > 0) {
      SubjectGradeWisePerformanceReport();
      PerformanceReportForGrade11And12();
    }else{
      SetGraphData({ Graph610: [], Graph112: [] });
      SetPerformace112(process.env.REACT_APP_NODATAFOUND_Participated);
       SetPerformanceOne(process.env.REACT_APP_NODATAFOUND_Participated);
    }
    GetAssmentdates();
  }, [SelectDate?.value,props.SSchoolId, props.HQUserid]);
  const [ASSGrade, SetAssGrade] = useState();
  const GetAssmentdates = async () => {
    // if(props.HQUserid === undefined) return;
    const Data = await InstituteGrades(items?.instituteId, SelectDate, USYear?.value, props.HQUserid || items.userId );
    const Grades = Data?.[0]?.grade?.split(",").filter((value) => value <= 10);
    SetAssGrade(Grades?.map((grade) => ({ display: `Grade ${grade}`, value: grade.trim() })));
  }
  const GetPColor = (e) => {
    const colors = {
      English: "#0B6EE3",
      Mathematics: "#3DA663",
      Biology: "#9951BB",
      BioTechnology: "#EE649E",
      Hindi:"#f96393",
      Telugu:"#AD46FF",
    };
    return colors[e] || "#F59E3C";
  };
  const NavigateTeacher = (Marks, section, subject, Grade) => {
    if (Marks !== undefined) {
      dispatch(
        PrincipalTeacherDashboarData({
          Section: section,
          Grade: Grade,
          SchoolId: props?.SSchoolId,
          HQUserId:props.HQUserid
        })
      );
      navigate("/Performance/SchoolPerformance");
    }
  };

  const renderTable = (data, Subjects, Sections) => (
    <>
      <table className="Principle-Table">
        <thead>
          <tr>
            <th rowSpan="2">Grade</th>
            {Subjects?.map((subject, index) => (
              <th
                colSpan={Sections.length}
                key={index}
                style={{ backgroundColor: GetPColor(subject), color: "#FFF" }}
              >
                {subject}
              </th>
            ))}
          </tr>
          <tr>
            {Subjects?.flatMap((subject, subjectIndex) =>
              Sections?.map((section, sectionIndex) => (
                <th
                  key={`section-${subjectIndex}-${sectionIndex}`}
                  style={{
                    color: GetPColor(subject),
                    textTransform: "capitalize",
                  }}
                >
                  {section}
                </th>
              ))
            )}
          </tr>
        </thead>
        <tbody>
          {data &&
            Object.values(data)?.map((item, index) => (
              <tr key={index}>
                <td>{NumberToRoman(item.grade)}</td>
                {Subjects.flatMap((subject, subjectIndex) => {
                  const subjectData = item.subjects[subject];
                  return Sections?.map((section, idx) => (
                    <td
                      key={`${idx}-${subjectIndex}`}
                      title="Click here to view Section wise detailed performance."
                      className={`CPointer ${subjectData?.[section]
                        ? "text-decoration-underline"
                        : ""
                        }`}
                      onClick={() => {
                        subjectData?.[section] &&
                          NavigateTeacher(
                            subjectData[section],
                            section.toUpperCase(),
                            subject,
                            item.grade
                          );
                      }}
                    >
                      {subjectData?.[section]
                        ? subjectData[section] + "%"
                        : "-"}
                    </td>
                  ));
                })}
              </tr>
            ))}
        </tbody>
      </table>
      <div className="Info-Message">
        Click on the <b>performance values</b> link to view the section wise
        performance
      </div>
    </>
  );

  const DownloadGraph = (e) => {
    if (e === "610") {
      DownloadGraphImage(Grade610Ref, `Subject wise performance ${AssessmentName(SelectDate?.assessmentType)} - Grade ${SelectGrade?.Grade610} - ${SelectDate?.examStartDate}`)
    } else if (e === "112") {
      DownloadGraphImage(Grade112Ref, `Subject wise performance ${AssessmentName(SelectDate?.assessmentType)} - Grade ${SelectGrade?.Grade112} - ${SelectDate?.examStartDate}`)
    }
  };

  const DownloadTables = async (Data, Subjects, Sections, Filename, HeaderName) => {
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet("Grades");

    // const levels = Sections;

    // Step 1: Add heading (merged row)
    const totalColumns = 2 + Subjects.length * Sections.length;
    worksheet.mergeCells(1, 1, 1, totalColumns);
    const headingCell = worksheet.getCell("A1");
    headingCell.value = HeaderName;
    headingCell.font = { bold: true, size: 16 };
    headingCell.alignment = { vertical: "middle", horizontal: "center" };

    // Step 2: Create header rows
    const headerRow1 = ["S.No", "Grade"];
    const headerRow2 = ["", ""];
    Subjects.forEach((subject) => {
      headerRow1.push(subject, ...Array(Sections.length - 1).fill(""));
      Sections.forEach((lvl) => headerRow2.push(lvl.toUpperCase()));
    });

    worksheet.addRow(headerRow1);
    worksheet.addRow(headerRow2);
    [2, 3].forEach((rowNum) => {
      worksheet.getRow(rowNum).eachCell((cell) => {
        cell.font = { bold: true };
      });
    });
    // Step 3: Merge subject headers
    worksheet.mergeCells(2, 1, 3, 1);
    worksheet.mergeCells(2, 2, 3, 2);
    // 2. Dynamically merge subject headers
    let startCol = 3; // Start after Grade column
    Subjects.forEach((subject) => {
      // const levelCount = ;
      const endCol = startCol + Sections.length - 1;
      worksheet.mergeCells(2, startCol, 2, endCol); // Merge for subject name in Row 2
      startCol = endCol + 1; // Move to next subject group
    });

    // Step 4: Add student data
    Object.values(Data).forEach((entry, index) => {
      const row = [index + 1, NumberToRoman(entry.grade)];
      Subjects.forEach((subject) => {
        Sections.forEach((lvl) => {
          const val = entry.subjects[subject]?.[lvl.toLowerCase()];
          row.push(val > 0 ? `${val}%` : "-");
        });
      });
      worksheet.addRow(row);
    });

    // Step 5: Center align all cells and add borders
    worksheet.eachRow((row) => {
      row.eachCell((cell) => {
        cell.alignment = { vertical: "middle", horizontal: "center" };
        cell.border = {
          top: { style: "thin" },
          left: { style: "thin" },
          bottom: { style: "thin" },
          right: { style: "thin" },
        };
      });
    });

    // Step 6: Adjust column widths
    worksheet.columns.forEach((col) => {
      col.width = 10;
    });

    // Step 7: Export
    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], {
      type:
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    saveAs(blob, `${Filename}.xlsx`);
  };
 return (
    <>
      <div className=" mt-3 dflex flexd-column principle-maindiv">
        {/* <div className="MainHeading">
          Section wise performance of {AssessmentName(SelectDate?.assessmentType)} -{" "}
          {SelectDate?.examStartDate}
        </div> */}

        {SelectDate?.assessmentType === 3 ?
          <div className="ErrorMessage">Performance reports will be available sooner</div>
          : <>

            <div className="container-fluid">
              <Row>
                <Col md="12" style={{ paddingLeft: "0px" }}>
                  <div className="dflex JSBetween alignitems ">
                    <div className="SubHeading mt-2">Grades l to X </div>
                    <div className="dflex gap-3">
                      {PerformanceOne?.[GetGrades?.[0]]?.grade && <ExportXlButton Name="Export to Excel" Click={() => DownloadTables(PerformanceOne, Subjects, Sections, `Section wise performance of ${AssessmentName(SelectDate?.assessmentType)} - I to X - ${SelectDate?.examStartDate}`, `Section wise performance of ${AssessmentName(SelectDate?.assessmentType)} - I to X - ${SelectDate?.examStartDate}`)} />}
                    </div>
                  </div>
                </Col>
              </Row>
            </div>
            <div className="container-fluid">
              <Row>
                <Col md="12" style={{ paddingLeft: "0px" }}>
                  <div className="Table-Card">
                    {PerformanceOne?.[GetGrades?.[0]]?.grade ? (
                      renderTable(PerformanceOne, Subjects, Sections)
                    ) : (
                      <div className="ErrorMessage">{PerformanceOne}</div>
                    )}
                  </div>
                </Col>
              </Row>
            </div>
            <Row>
              <Col>
                <div className="dflex JSBetween alignitems mb-2 mt-2">
                  <div className="SubHeading  ">Grades XI & XII</div>
                  {Performace112?.[GetGrades112?.[0]]?.grade && <ExportXlButton Name="Export to Excel" Click={() => DownloadTables(Performace112, Subjects112, Sections112, `Section wise performance of ${AssessmentName(SelectDate?.assessmentType)} - XI to XII - ${SelectDate?.examStartDate}`, `Section wise performance of ${AssessmentName(SelectDate?.assessmentType)} - XI to XII - ${SelectDate?.examStartDate}`)} />}</div>

                {
                  <div className="Table-Card">
                    {" "}
                    {Performace112?.[GetGrades112?.[0]]?.grade ? (
                      renderTable(Performace112, Subjects112, Sections112)
                    ) : (
                      <div className="ErrorMessage m-2"> {Performace112} </div>
                    )}{" "}
                  </div>
                }
              </Col>
            </Row>

            <Row className="dflex p-2" style={{ gap: "10px" }}>
              <Col className="dflex flexd-column Card" style={{ gap: "5px" }}>
                <div className="w-100">
                  <div className="dflex JSBetween alignitems">
                    <div className="SubHeading">
                      Subject wise performance (Grades l - X)
                    </div>
                    <div className="dflex gap-3">
                      {ASSGrade?.length>0 ? 
                      <DropdownValues className="NCLDropdown" options={ASSGrade}
                        selectoption={SelectGrade.Grade610}
                        onChange={(e) => { SetSelectGrade((prevState) => ({ ...prevState, Grade610: parseInt(e.target.value) })) }} /> : ""}
                      {GraphData.Graph610 &&
                        GraphData.Graph610.filter(
                          (grade) => grade.grade === SelectGrade.Grade610
                        ).length > 0 && <DownloadGraphButton Click={() => DownloadGraph("610")} />}
                    </div>
                  </div>

                  {GraphData.Graph610 &&
                    GraphData.Graph610.filter(
                      (grade) => grade.grade === SelectGrade.Grade610
                    ).length > 0 ? (
                    <GroupedStackedBarchart Ref={Grade610Ref}
                      Labels={Sections}
                      Grade={SelectGrade.Grade610}
                      Data610={GraphData.Graph610}
                    />
                  ) : (
                    <div className="ErrorMessage ">
                      {GraphData.Graph610 &&
                        GraphData.Graph610.filter(
                          (grade) => grade.grade === SelectGrade.Grade610
                        ).length === 0
                        ? process.env.REACT_APP_NODATAFOUND_Participated
                        : PerformanceOne}
                    </div>
                  )}
                </div>
              </Col>
              <Col className="dflex flexd-column Card" style={{ gap: "5px" }}>
                <div className="w-100">
                  <div className="dflex JSBetween alignitems">
                    <div className="SubHeading">
                      Subject wise performance (Grades Xl - Xll)
                    </div>
                    {GraphData?.Graph112 && GraphData?.Graph112?.filter(
                      (grade) => grade.grade === SelectGrade.Grade112
                    ).length > 0 && <DownloadGraphButton Click={() => DownloadGraph("112")} />}
                  </div>
                  <div className="Class-Navigations dflex">
                    {[11, 12].map((grade) => (
                      <div
                        key={grade}
                        onClick={() =>
                          SetSelectGrade((prevState) => ({
                            ...prevState,
                            Grade112: grade,
                          }))
                        }
                        style={{
                          color:
                            SelectGrade.Grade112 === grade ? "#1CA27A" : "inherit",
                        }}
                      >
                        {" "}
                        Grade - {NumberToRoman(grade)}{" "}
                      </div>
                    ))}
                  </div>
                  {GraphData.Graph112 &&
                    GraphData.Graph112?.filter(
                      (grade) => grade.grade === SelectGrade.Grade112
                    ).length > 0 ? (
                    <GroupedStackedBarchart Ref={Grade112Ref}
                      Labels={Sections112}
                      Grade={SelectGrade.Grade112}
                      Data610={GraphData.Graph112}
                    />
                  ) : (
                    <div className="ErrorMessage">
                      {GraphData.Graph112 &&
                        GraphData.Graph112?.filter(
                          (grade) => grade.grade === SelectGrade.Grade112
                        ).length === 0
                        ? process.env.REACT_APP_NODATAFOUND_Participated
                        : Performace112}
                    </div>
                  )}
                </div>
              </Col>
            </Row>
          </>}
      </div>
      {Load && <Loading />}
    </>
  );
};
export default HQAPP;
